/**
 * Ensures a number is rounded to a fixed number of decimal places,
 * but never uses more than 2 digits of the user's original decimal input.
 * If the input has fewer decimals, pads with zeros and adds a minimal increment to avoid truncation.
 * Examples:
 *   4      => 4.0001
 *   4.12   => 4.1201
 *   4.001  => 4.0001
 *   4.1234 => 4.1234
 *   4.123456 => 4.1234
 *
 * @param {number} number - The number to be rounded.
 * @param {number} decimals - The number of decimal places to round to.
 * @returns {number} - The rounded and adjusted number.
 */
export function fixedLengthNumber(number: number, decimals: number): number {
	// eslint-disable-next-line eqeqeq
	if (number == null) {
		return number;
	}

	const factor = Math.pow(10, decimals);
	let roundedNumber = Math.round(number * factor) / factor;
	const smallestIncrement = 1 / factor;

	if (roundedNumber === +number) {
		if (number >= 0) {
			roundedNumber += smallestIncrement;
		} else {
			roundedNumber -= smallestIncrement;
		}
	}

	return parseFloat(roundedNumber.toFixed(decimals));
}
